var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg100({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.635735 32.5C0.635735 50.3743 15.1257 64.8643 33 64.8643C50.8743 64.8643 65.3643 50.3743 65.3643 32.5C65.3643 14.6257 50.8743 0.135742 33 0.135742C15.1257 0.135742 0.635735 14.6257 0.635735 32.5ZM51.7348 32.5C51.7348 42.8469 43.3469 51.2348 33 51.2348C22.6531 51.2348 14.2652 42.8469 14.2652 32.5C14.2652 22.1531 22.6531 13.7652 33 13.7652C43.3469 13.7652 51.7348 22.1531 51.7348 32.5Z",
    fill: "#52C41A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0.135742C39.401 0.135742 45.6583 2.03387 50.9806 5.5901C56.3029 9.14633 60.4511 14.2009 62.9007 20.1147C65.3502 26.0285 65.9912 32.5359 64.7424 38.814C63.4936 45.092 60.4112 50.8588 55.885 55.385C51.3588 59.9112 45.592 62.9936 39.314 64.2424C33.0359 65.4912 26.5285 64.8503 20.6147 62.4007C14.7009 59.9511 9.64633 55.8029 6.0901 50.4806C2.53387 45.1583 0.635735 38.9011 0.635735 32.5H14.2652C14.2652 36.2054 15.364 39.8276 17.4226 42.9085C19.4812 45.9894 22.4072 48.3907 25.8305 49.8087C29.2538 51.2267 33.0208 51.5977 36.655 50.8748C40.2892 50.1519 43.6274 48.3676 46.2475 45.7475C48.8676 43.1274 50.6519 39.7892 51.3748 36.155C52.0977 32.5208 51.7266 28.7539 50.3087 25.3305C48.8907 21.9072 46.4894 18.9812 43.4085 16.9226C40.3276 14.864 36.7054 13.7652 33 13.7652V0.135742Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100);
export default __webpack_public_path__ + "static/media/100.64cdfd1a9422d985a97b53f974457d4a.svg";
export { ForwardRef as ReactComponent };